module.exports = __webpack_public_path__ + "static/media/clean.79f92a54.svg";